export default { sha: 'ce71b78853995abf53befdc23d42c83d2e6a55b4', buildNumber: 'undefined' }
